import React from 'react';
import { CtaButton } from './CtaButton';
import { CycleMark } from './CycleMark';
import { ProductStack } from './ProductStack';
const chips = ['6 Volumes', '124 Field Procedure Cards', '38 Worksheets', '5 Bonuses', 'Cube · Nugget · Flake'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Brand-agnostic — use it beside any service manual'];

// Los 4 sistemas del producto (Water, Refrigeration, Harvest, Controls)
const systems = ['bg-sys-water', 'bg-sys-refrig', 'bg-sys-harvest', 'bg-sys-controls'];
export function Hero() {
  return <section className="grid-dark relative w-full overflow-hidden border-b-4 border-ember bg-forest-deep" data-id="element-129" data-mp="saruosa8z4d0">
      <CycleMark className="pointer-events-none absolute -right-24 -top-12 h-[360px] w-[360px] text-sky/[0.09] sm:h-[460px] sm:w-[460px]" data-id="element-130" data-mp="ncztf7npq5w5" />

      <div className="relative z-10 mx-auto max-w-6xl px-5 pb-14 pt-7 sm:pb-20 sm:pt-12" data-id="element-131" data-mp="3d2tqbf4z2uh6">
        <div className="grid items-center gap-8 lg:grid-cols-[1.05fr_.95fr] lg:gap-14" data-id="element-132" data-mp="380w020y5mzeq">
          <div data-id="element-133" data-mp="3j9u0yz9q1olt">
            <p className="eyebrow text-sky" data-id="element-134" data-mp="3j9ah3d0igq55">
              For commercial refrigeration &amp; ice machine techs
            </p>
            <h1 className="mt-3 font-display text-[40px] uppercase leading-[1] text-paper sm:text-6xl md:text-7xl" data-id="element-135" data-mp="39acysrtohsul">
              Stop swapping parts.{' '}
              <span className="text-ember" data-id="element-136" data-mp="3e7uwfm28wlna">Split the cycle first.</span>
            </h1>
            <p className="mt-4 max-w-xl text-base leading-relaxed text-paper/80 sm:text-lg" data-id="element-137" data-mp="30h9blrt8e1mr">
              Ice Machine Diagnostic Pro is the Freeze-or-Harvest field system
              that takes you from the customer’s complaint to the faulty part on
              cube, nugget and flake machines — symptom flowcharts, component
              tests, cleaning and sanitation procedures, and 38 service forms
              ready to fill. Not another code table: the whole call, from the
              first 15 minutes to the signed report.{' '}
              <span className="font-semibold text-paper" data-id="element-138" data-mp="2lml98mj4njbd">
                Brand-agnostic, and built to work beside the manufacturer’s
                manual.
              </span>
            </p>
            <ul className="mt-5 flex flex-wrap gap-2" data-id="element-139" data-mp="n9i53fyz3kvp">
              {chips.map(chip => <li key={chip} className="rounded-md border border-paper/25 bg-paper/10 px-3 py-1.5 text-[11px] font-bold uppercase tracking-wide text-paper/90" data-id="element-140" data-mp="ia5fingpvzpf">
                  {chip}
                </li>)}
            </ul>
          </div>

          <ProductStack data-id="element-141" data-mp="15zzr71pavi83" />
        </div>

        <div className="mt-8 flex flex-col items-center" data-id="element-142" data-mp="111y9ak3m1oy7">
          <div className="w-full max-w-md" data-id="element-143" data-mp="114kg2hiog0fd">
            <CtaButton data-id="element-144" data-mp="x031qxv36fbz">Get Ice Machine Diagnostic Pro</CtaButton>
          </div>

          <div className="mt-5 flex max-w-md flex-col items-center gap-2.5 text-center sm:flex-row sm:text-left" data-id="element-145" data-mp="3ltgnrsgieupe">
            <ul className="flex -space-x-1.5" aria-hidden="true" data-id="element-146" data-mp="3hqaian1817jz">
              {systems.map(color => <li key={color} className={`h-7 w-7 rounded-full border-2 border-forest-deep ${color}`} data-id="element-147" data-mp="1xam5wruslszg" />)}
            </ul>
            <p className="text-[13px] leading-snug text-paper/70" data-id="element-148" data-mp="268y53i9q5z3i">
              Built for the field techs, lead techs and shop owners who keep
              ice machines running — in the US, UK, Canada and Australia.
            </p>
          </div>

          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-paper/65" data-id="element-149" data-mp="2g256yt59awyu">
            {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-150" data-mp="2p08we0jd4dvx">
                <span className="h-1.5 w-1.5 rounded-full bg-ember" data-id="element-151" data-mp="2tzlfqbb0z2tr" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}